import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-firebase-error',
  templateUrl: './firebase-error.component.html',
  styleUrls: ['./firebase-error.component.scss']
})
export class FirebaseErrorComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
